import React from 'react';
import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

import { MultiColumnCta } from '@ahc-digital/component-library';
import { CreateMultiColumnCTAsModel } from './C05MulticolumnCTAs.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C05MulticolumnCTAsProps = RenderingProps<
  C05MulticolumnCTAsFields,
  C05MulticolumnCTARenderingParams
>;

export type C05MulticolumnCTAsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
};

export type C05MulticolumnCTARenderingParams = {
  NumberOfColumns?: string;
  Theme?: string;
  TitleType?: string;
  TitleAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export const Default = (props?: C05MulticolumnCTAsProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <MultiColumnCta
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateMultiColumnCTAsModel(props)}
    />
  );
};
